import type { K8s } from '@/entities/kubernetes';
import request from '@/shared/api/request';

export const createKubernetes = (data: {
  name: string;
  version: string;
  region: string;
  node_pool: {
    name: string;
    size: string;
    count: number;
  };
  project_uuid?: string;
  tags: string[];
}): Promise<{
  kubernetes: K8s;
}> =>
  request({
    url: '/kubernetes/',
    method: 'POST',
    data,
  });
